module.exports = __webpack_public_path__ + "img/LocationCityOutlined.19359a0a.svg";